import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted to GTS }}\n<DeskLandingPage/>",{ moduleName: "garaje/pods/desks/landing-page/template.hbs" })